import clsx from 'clsx';
import { forwardRef, type SelectHTMLAttributes } from 'react';

interface SelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
  /** Marks the field as failing validation — red border + focus ring. */
  invalid?: boolean;
}

export const Select = forwardRef<HTMLSelectElement, SelectProps>(
  function Select({ className, invalid, children, ...rest }, ref) {
    return (
      <select
        ref={ref}
        aria-invalid={invalid || undefined}
        className={clsx(
          'w-full rounded-md border bg-[var(--input-bg)] px-2 py-1 text-xs font-semibold text-[var(--text-primary)] outline-none transition',
          'sm:rounded-lg sm:px-3 sm:py-2 sm:text-sm',
          'disabled:cursor-not-allowed disabled:opacity-60',
          invalid
            ? 'border-danger ring-1 ring-danger/40 focus:border-danger'
            : 'border-[var(--border-color)] focus:border-accent',
          className,
        )}
        {...rest}
      >
        {children}
      </select>
    );
  },
);
